import { all, call, fork, put, select, takeEvery } from "redux-saga/effects";
import { GET } from "../../helpers/apiHelper";
import * as action from "./actions";

export const getListState = (state) => state.entraLogApp.list;

const loadEntraLogListAsync = async (query) => GET(`/giga-school-api-log?${query}`);

function* loadEntraLogList({ payload }) {
  try {
    const list = yield select(getListState);
    console.log('entra saga payload:', payload);
    let param = [
      {
        name: "page",
        value: payload.selectedPage,
      },
      {
        name: "limit",
        value: payload.limit,
      },
      {
        name: "orderby",
        value: list.orderBy,
      },
      {
        name: "sortedby",
        value: list.sortedBy,
      },
      {
        name: "deleteFlag",
        value: encodeURIComponent(payload.deleteFlag),
      },
    ];

    // Add date range filters if provided
    if (payload.startDate) {
      console.log('Adding startDate:', payload.startDate);
      param.push({
        name: "startDate",
        value: payload.startDate,
      });
    }

    if (payload.endDate) {
      console.log('Adding endDate:', payload.endDate);
      param.push({
        name: "endDate",
        value: payload.endDate,
      });
    }

    if (payload.importType === "MANUAL" || payload.importType === "AUTO") {
      param.push({
        name: "importType",
        value: payload.importType,
      });
    }

    if (payload.syncType === "entra_id" || payload.syncType === "google_workspace") {
      param.push({
        name: "syncType",
        value: payload.syncType,
      });
    }

    if (list.filter || "") {
      param = [
        ...param,
        ...[
          {
            name: "search",
            value: list.filter,
          },
        ],
      ];
    }
    const queryString = param.map((t) => `${t.name}=${t.value}`).join("&");
    console.log('Final entra query string:', queryString);
    const response = yield call(loadEntraLogListAsync, queryString);
    yield put(action.loadEntraLogListSuccess(response));
  } catch (error) {
    console.log('loadEntraLogList error', error)
    yield put(action.loadEntraLogListError(error));
  }
}

export function* watchLoadEntraLogList() {
  yield takeEvery(action.ENTRA_LOG_GET_LIST, loadEntraLogList);
}

export default function* rootSaga() {
  yield all([
    fork(watchLoadEntraLogList),
  ]);
}
